import { IGame } from '@/interface/game';
import ARMobileViewWrapper from '../common/ARMobileViewWrapper';
import GameScreenContent from './GameScreen/GameScreenContent';

type ARGameContentProps = {
  game: IGame;
  customDomain?: string;
};
const ARGameContent = ({ game, customDomain }: ARGameContentProps) => {
  return (
    <ARMobileViewWrapper
      gameId={game?._id || ''}
      game={game}
      customDomain={customDomain}
    >
      <GameScreenContent game={game} />
    </ARMobileViewWrapper>
  );
};

export default ARGameContent;
